import { render, staticRenderFns } from "./CheckItem.vue?vue&type=template&id=32ba5883&scoped=true&"
import script from "./CheckItem.vue?vue&type=script&lang=js&"
export * from "./CheckItem.vue?vue&type=script&lang=js&"
import style1 from "./CheckItem.vue?vue&type=style&index=1&id=32ba5883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba5883",
  null
  
)

export default component.exports